import React, { useEffect, useState } from "react";
import { intakeYears } from "../../utilis/constants";
import ProviderSettingsModal from "./ProviderSettingsModal";

const inputClass =
  "w-full rounded-lg border border-gray-200 bg-white px-3 py-2.5 text-sm text-gray-800 outline-none transition focus:border-blue-500 focus:ring-2 focus:ring-blue-100";

const INTAKE_QUARTERS = ["Q1", "Q2", "Q3", "Q4"];

function ProviderIntakeModal({
  show,
  isEditing = false,
  defaultMonths = "",
  defaultQuarter = "",
  defaultYear = "",
  saving = false,
  onClose,
  onSubmit,
}) {
  const [months, setMonths] = useState(defaultMonths);
  const [quarter, setQuarter] = useState(defaultQuarter);
  const [year, setYear] = useState(defaultYear);

  useEffect(() => {
    if (show) {
      setMonths(defaultMonths || "");
      setQuarter(defaultQuarter || "");
      setYear(defaultYear || "");
    }
  }, [show, defaultMonths, defaultQuarter, defaultYear]);

  const handleSubmit = () => {
    onSubmit?.(months.trim(), quarter, year);
  };

  return (
    <ProviderSettingsModal
      show={show}
      title={isEditing ? "Edit Intake" : "New Intake"}
      onClose={onClose}
      onSubmit={handleSubmit}
      submitLabel={isEditing ? "Update" : "Add"}
      saving={saving}
    >
      <div className="mb-4">
        <label className="mb-1.5 block text-sm font-semibold text-gray-700">
          Add New Intake
        </label>
        <input
          type="text"
          autoFocus
          placeholder="Please enter months"
          value={months}
          onChange={(event) => setMonths(event.target.value)}
          className={inputClass}
        />
        <small className="mt-1.5 block text-xs text-gray-500">
          E.g (Jan, Feb, Mar)
        </small>
      </div>

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        <div>
          <label className="mb-1.5 block text-sm font-semibold text-gray-700">
            Quarter
          </label>
          <select
            value={quarter}
            onChange={(event) => setQuarter(event.target.value)}
            className={inputClass}
          >
            <option value="">Select Quarter</option>
            {INTAKE_QUARTERS.map((item) => (
              <option key={item} value={item}>
                {item}
              </option>
            ))}
          </select>
        </div>

        <div>
          <label className="mb-1.5 block text-sm font-semibold text-gray-700">
            Year
          </label>
          <select
            value={year}
            onChange={(event) => setYear(event.target.value)}
            className={inputClass}
          >
            <option value="">Select Year</option>
            {intakeYears.map((item) => (
              <option key={item.name} value={item.name}>
                {item.name}
              </option>
            ))}
          </select>
        </div>
      </div>
    </ProviderSettingsModal>
  );
}

export default ProviderIntakeModal;
